import ManageSectionsAndQuestions from "../components/siteVisits/ManageSectionsAndQuestions";
import ManageOptionEntries from "../components/siteVisits/ManageOptionEntries";
import ManageSectionConditions from "../components/siteVisits/ManageSectionConditions";

export const siteVisitRoutes = [
  {
    path: "/SiteVisits/manage-sections",
    component: ManageSectionsAndQuestions,
  },
  {
    path: "/SiteVisits/manage-options",
    component: ManageOptionEntries,
  },
  {
    path: "/SiteVisits/manage-conditions",
    component: ManageSectionConditions,
  },
];
